:root {
  --primary-50: hsl(313.333333, 100%, 98.235294%);
  --primary-100: hsl(321.176471, 100%, 96.666667%);
  --primary-150: hsl(320, 92.307692%, 94.901961%);
  --primary-200: hsl(321.290323, 88.571429%, 93.137255%);
  --primary-250: hsl(318.461538, 82.978723%, 90.784314%);
  --primary-300: hsl(317.5, 80%, 88.235294%);
  --primary-350: hsl(315, 77.777778%, 85.882353%);
  --primary-400: hsl(313.333333, 74.117647%, 83.333333%);
  --primary-450: hsl(314.157303, 73.553719%, 76.27451%);
  --primary-500: hsl(315, 72.5%, 68.627451%);
  --primary-550: hsl(314.482759, 70.731707%, 59.803922%);
  --primary-600: hsl(312.964824, 84.680851%, 46.078431%);
  --primary-650: hsl(313.371429, 87.939698%, 39.019608%);
  --primary-700: hsl(313.509934, 92.638037%, 31.960784%);
  --primary-750: hsl(313.700787, 96.946565%, 25.686275%);
  --primary-800: hsl(314.257426, 100%, 19.803922%);
  --primary-850: hsl(314.805195, 100%, 15.098039%);
  --primary-900: hsl(316.363636, 100%, 10.784314%);
  --primary-950: hsl(319.411765, 100%, 6.666667%);
  --accent-50: hsl(26.666667, 100%, 98.235294%);
  --accent-100: hsl(28.235294, 100%, 96.666667%);
  --accent-150: hsl(26.086957, 92%, 95.098039%);
  --accent-200: hsl(28, 88.235294%, 93.333333%);
  --accent-250: hsl(28.75, 96%, 90.196078%);
  --accent-300: hsl(29.090909, 100%, 87.058824%);
  --accent-350: hsl(30.714286, 100%, 83.529412%);
  --accent-400: hsl(31.176471, 100%, 80%);
  --accent-450: hsl(27.969925, 97.080292%, 73.137255%);
  --accent-500: hsl(25.398773, 95.321637%, 66.470588%);
  --accent-550: hsl(22.736842, 92.23301%, 59.607843%);
  --accent-600: hsl(20, 90%, 52.941176%);
  --accent-650: hsl(18.181818, 82.5%, 47.058824%);
  --accent-700: hsl(16.243094, 86.602871%, 40.980392%);
  --accent-750: hsl(14.545455, 93.220339%, 34.705882%);
  --accent-800: hsl(10.945946, 100%, 29.019608%);
  --accent-850: hsl(7.826087, 100%, 22.54902%);
  --accent-900: hsl(2.891566, 100%, 16.27451%);
  --accent-950: hsl(0, 100%, 10.392157%);
  --grey-50: hsl(0, 0%, 98.039216%);
  --grey-100: hsl(0, 0%, 96.078431%);
  --grey-150: hsl(0, 0%, 94.117647%);
  --grey-200: hsl(0, 0%, 92.156863%);
  --grey-250: hsl(200, 5.660377%, 89.607843%);
  --grey-300: hsl(195, 6.060606%, 87.058824%);
  --grey-350: hsl(197.142857, 8.860759%, 84.509804%);
  --grey-400: hsl(200, 9.89011%, 82.156863%);
  --grey-450: hsl(204, 6.25%, 68.627451%);
  --grey-500: hsl(198, 4.385965%, 55.294118%);
  --grey-550: hsl(198, 4.587156%, 42.745098%);
  --grey-600: hsl(201.818182, 7.006369%, 30.784314%);
  --grey-650: hsl(204, 7.352941%, 26.666667%);
  --grey-700: hsl(204, 8.62069%, 22.745098%);
  --grey-750: hsl(204, 10.416667%, 18.823529%);
  --grey-800: hsl(206.666667, 11.688312%, 15.098039%);
  --grey-850: hsl(205.714286, 12.727273%, 10.784314%);
  --grey-900: hsl(204, 15.151515%, 6.470588%);
  --grey-950: hsl(210, 28.571429%, 2.745098%);
}
